import * as obj from "../../common/adhesion/objects";
import Sales from "../../../services/sales";
import Auth from "../../../services/auth";
import VehicleServices from "../../../services/vehicles"; // busca de veículo CAP-169
import vehicles from '../../common/adhesion/vehicles.vue'
import Contracts from "../../../services/contracts";
import Account from "../../../services/account";
import C from "../../common/constantes";
import ChoosePaymentNewContract from "../contract/choose-payment-new-contract.vue";
import SummaryVehicle from "../vehicle/summary-vehicle.vue";
import GenericSummary from "../../common/generic-summary.vue";
import successPage from "../../common/adhesion/success.vue";
import errorPage from "../../common/adhesion/error.vue";
import addressComp from "../../common/address.vue";
import messageDialog from "../../../components/message-dialog.vue";
import * as Utils from "../../../utils";
import chooseNewPlan from "./choose-new-plan.vue";
import choosePlan from "../../common/adhesion/choose-plan.vue";
import chooseRecharge from "../../common/adhesion/choose-recharge.vue";
import plans from "../plans";

import { EventBus } from "../../../event-bus";
import Financial from "../../../services/financial";

import b2c from "../../external/plans/b2c.vue";
import b2b from "../../external/plans/b2b.vue";
import vpo from "../../external/plans/vpo.vue";
import payment from "../../common/payment/payment";

const subs = [
  "Escolha o plano do novo contrato:",
  "",
  "Cadastre os veículos que irão utilizar o plano:",
  "Informe a forma de pagamento:",
  "",
];

export default {
  data() {
    return {
      contract: obj.contract(),
      contractProp: [],
      creditCardOptions: [],
      bankAccountOptions: [],
      bankBillOption: undefined,
      newVehicleTax: undefined,
      vehicles: [],
      // payment: obj.payment(),
      planId: undefined,
      planName: undefined,
      step: 0,
      subtitle: subs,
      msgError: undefined,
      loading: undefined,
      success: false,
      contractPaymentMethodId: undefined,
      paymentSelected: obj.payment(),
      code: undefined,
      boletoUrl: undefined,
      changeAddress: false,
      newAddress: Auth.currentUser.address,
      secureCodeCreditCard: undefined,
      qtdAllowed: C.qtdAllowed,
      guaranteeTax: undefined,
      lead: undefined,
      newAhesionTax: undefined,
      newVehicleTax: undefined,
      // guaranteeTax: undefined,
      showRecharge: true,
      minValue: 200000,
      total: undefined,
      salesOrder: undefined,
      address: undefined,
      promotionCode: undefined,
      shipmentType: undefined,
      novoCartao: undefined,
      salesResponse: undefined,
      rodosol: undefined,
      vehicleByContract: undefined,
      contractNew: [],
      cpm: { error: "Verifique o preenchimento dos campos" },
    };
  },

  watch: {
    step(newVal, oldVal){
      
      this.step == 2 ? this.total = this.salesOrder.price : this.total;
      if (oldVal == 2 && newVal == 1 ){
        this.salesOrder.products.splice(1, Number.MAX_VALUE) 
      }       
    },
  },

  computed: {
    user() {
      return Auth.currentUser;
    },

    rodosolCheck() {
      return this.$route.params.rodosol;
    },

    request() {
      let vm = this;
      let request = {
        _interface: window.document.webview ? "MOBILE" : "WEBSITE",
        account: vm.account,
        addresses: {
          address: [vm.address],
        },
        contract: vm.contract,
        listVehicle: {
          vehicle: vm.vehicles,
        },
        value: this.total,
        shipmentType: this.shipmentType,
      };
      return request;
    },
  },

  created() {
    EventBus.$on("migrationPlan", this.choosePlan);
    EventBus.$on("cleanErrors", () => {
      this.msgError = undefined;
    });
    EventBus.$on("setPayment", (payment) => {
      
      this.doRequest(payment);
    });
  },

  mounted() {
    let vm = this;
    this.contractProp = this.$route.params.contract;
    this.rodosol = this.rodosolCheck;
    VehicleServices.getVehicleByContractIdV2(this.contractProp.contractId).then(
      (response) => (this.vehicleByContract = response.Vehicles)
    );
  },

  methods: {
    planoEscolhidoCallback(planId) {
      
      this.nextStep();
      this.planId = planId;
    },

    getPayment() {
      this.$refs.GenericSummary.getPayment();
    },
    choosePlan(planId, planName) {
      
      this.planId = planId;
      this.planName = planName;
      this.contractProp.plan = {
        planId,
      };
      this.getPlanInfo().then((r) => {
        this.$router.push({
          name: "migration-plan",
          query: {
            planId,
          },
        });
        this.nextStep();
      });
    },
    nextStep() {
      this.msgError = undefined;
      $("body").stop().animate(
        {
          scrollTop: 0,
        },
        "500",
        "swing"
      );
      switch (this.step) {

        case 0:
          if (this.rodosol == true) {
            
            let value =
              this.vehicleByContract.length * this.newVehicleTax + this.vehicleByContract.length * this.guaranteeTax;

            this.salesOrder = {
              _interface: "WEBSITE",
              // "date": new Date(),
              planId: this.planId,
              status: null,
              type: "MIGRAÇÃO DE PLANO",
              salesType: "MIGRATIONPLAN",
              taxpayerIdSeller: null,
              promotionCode: this.promotionCode,
              price: value,
              logisticsDistribution: null,
              paymentMethod: null,
              bankBillUrl: null,
              transactionPassageId: null,
              vehicleId: null,
              contract: this.contractProp.contractId,
              shipment: null,
              vehicles: this.vehicleByContract,
              products: [{
                productId: 1,
                productName: "ADESÃO",
                valueUnit: this.newVehicleTax,
                quantity: this.vehicleByContract.length,
                valueTotal: value,
              }],
            };

            this.step += 1;
          }

          break;

        case 1:
          this.salesOrder.products.push({
            "productId": 2,
            "productName": "RECARGA",
            "valueUnit": this.contract.rechargeValue,
            "quantity": 1,
            "valueTotal": this.contract.rechargeValue
          });
          this.salesOrder.products.push({
            "productId": 3,
            "productName": "TAXA DE RECARGA",
            "valueUnit": this.contract.taxRecharge,
            "quantity": 1,
            "valueTotal": this.contract.taxRecharge
          });

          this.salesOrder.price = (this.vehicleByContract.length  * this.newVehicleTax) + (this.vehicleByContract.length * this.guaranteeTax) + this.contract.rechargeValue + this.contract.taxRecharge;
          // this.salesOrder.price += this.contract.tax + this.contract.rechargeValue;

          this.step += 1;
          break;
      }
    },
    backStep() {
      this.msgError = undefined;
      $("body").stop().animate(
        {
          scrollTop: 0,
        },
        "500",
        "swing"
      );
      if (this.changeAddress) this.changeAddress = false;
      else this.step -= 1;
    },
    cancelar() {
      messageDialog
        .show({
          title: "Cancelar Migração",
          message: "Deseja cancelar o processo de migração?",
          type: "OK-CANCEL-ADHESION",
        })
        .then((res) => {
          if (res == "OK") {
            this.$router.push({
              name: "plans",
            });
          }
        });
    },
    getPlanInfo() {
      this.loading = Sales.getPlanById(this.planId).then((resp) => {
        
        this.newAhesionTax = this.newVehicleTax = _.filter(
          resp.adhesionTax.adhesionTax,
          (o) => {
            return o.taxId == C.NEW_VEHICLE_TAXID;
          }
        )[0].value;

        if (this.planId == 33 || this.planId == 34) {
          this.guaranteeTax = _.filter(resp.adhesionTax.adhesionTax, (o) => {
            return o.taxId == C.GUARANTEE_TAXID;
          })[0].value;
          this.showRecharge = false;
        } else {
          this.guaranteeTax = 0;
        }

        this.planName = resp.name;

        // formas de pagamento do plano escolhido
        _.each(resp.paymentMethod.paymentMethod, (o) => {
          o.value = o.paymentMethodId;
          o.caption = o.name;
          if (o.type == "BC") {
            o.billNumber = o.paymentMethodId;
            o.priority = 1;
            this.bankBillOption = {
              bankBill: o,
              paymentMethodId: o.paymentMethodId,
              imagePath: o.imagePath,
              billNumber: o.paymentMethodId,
              priority: 1,
            };
          } else if (o.type == "DC") this.bankAccountOptions.push(o);
          else if (o.type == "CC") this.creditCardOptions.push(o);
        });
      });
      return this.loading;
    },
    doRequest(payment) {
      if (
        (this.planId == 21 ||
          this.planId == 22 ||
          this.planId == 35 ||
          this.planId == 36 ||
          this.salesType != "MIGRATIONPLAN") &&
        payment.contractPaymentMethodId == null
      ) {
        this.novoCartao = true;
      }

      // TODO fixando regra cupom senff com forma pagamento senff
      if (
        this.promotionCode == "#SENFF_MM" &&
        payment.paymentMethod.paymentMethodId != 21
      ) {
        window.setTimeout(function () {
          messageDialog.show({
            title: "Ops!",
            headerClass: "modal-danger",
            message:
              "Este cupom de desconto é valido somente para pagamentos utilizando cartões Senff, por favor remova o cupom para continuar, ou realize o pagamento com um cartão Senff",
          });
        }, 1000);

        return;
      }

      // this.$refs.summaryVehicle.$validator.validateAll().then(r => {
      let value =
        this.vehicleByContract.length * this.newVehicleTax + this.vehicleByContract.length * this.guaranteeTax;

      const req = {
        contractId: this.contractProp.contractId,
        contract: this.contractProp,
        moveMaisId: this.user.moveMaisId,
        planId: this.contractProp.plan.planId,
        deliveryAddressId: this.address.addressId,
        contractPaymentMethod: payment,
        value: this.salesOrder.price,
        promotionCode: this.promotionCode,
        secureCode: this.user.taxIdNumber.substring(0, 4),
        _interface: window.document.webview ? "MOBILE" : "WEBSITE",
        vehicles: this.vehicleByContract,
        adhesionTax: this.newAhesionTax,
        salesOrder: this.salesOrder,
        rechargeValue: this.contract.rechargeValue



        // shipmentType: this.shipmentType,
      };

      // req.contract = _.cloneDeep(this.contract);
      // req.contractPaymentMethod = _.cloneDeep(payment);

      

      let url_atual = window.location.href;

      if (url_atual != "") {
        var regexp = new RegExp(/\S+pdv\S+/i);
        var n = regexp.test(url_atual);
        if (n) {
          // alert(n);
          //
          req["promotionCode"] = "GRAALKM29";
          req["logisticsDistribution"] = "FOB";
          //return;
        }
        //
      }

      if (Utils.isCaminhoParana(this.planId)) {
        req["promotionCode"] = "CAMINHOSDOPARANA";
        req["logisticsDistribution"] = "FOB";
      }

      // transforma true ou false da flag de aviso de limite de saldo para 1 ou 0
      // req.contract.lcFlag = req.contract.lcFlag ? 1 : 0;

      // if(req.shipmentType == 3){
      //   req.logisticsDistribution = "FOB";
      // }

      //

      this.loading = Sales.migrationPlan(req)
        .catch((err) => {
          const data = (err && err.data) || {};
          const status = data.status || {};
          this.code = status.code;
          this.msgError = status.message || data.message;
          this.salesResponse = undefined;
          $("body").stop().animate(
            {
              scrollTop: 0,
            },
            "500",
            "swing"
          );
        });
      // });
    },

    onPaymentSelected(value) {
      this.paymentSelected = value;
    },
    goToStep(value) {
      this.code = undefined;
      this.step = value;
    },
    saveAddress() {
      this.$refs.addressMailing.$validator.validateAll().then((success) => {
        this.loading = Account.updateAddress(this.newAddress)
          .then((r) => {
            this.changeAddress = false;
            let user = Auth.currentUser;
            user.address = this.newAddress;
            Auth.currentUser = user;
          })
          .catch((err) => {
            messageDialog.show({
              title: "Erro",
              message: err.data.status.message,
              headerClass: "modal-danger",
            });
          });
      });
    },
    eventChangeAddress(newValue) {
      this.changeAddress = newValue;
    },
    setTotal(t) {
      this.total = t;
    },
    startRequest() {
      this.$refs.GenericSummary.getInfos().then((r) => {
        
        this.address = r.address;
        this.promotionCode = r.promotionCode;
        this.cpm = this.$refs.GenericSummary.getPayment();

        this.doRequest(this.cpm)
      });
    },
  },
  beforeDestroy() {
    
    EventBus.$off("setPayment");
  },

  components: {
    vehicles,
    ChoosePaymentNewContract,
    SummaryVehicle,
    successPage,
    errorPage,
    addressComp,
    chooseNewPlan,
    choosePlan,
    chooseRecharge,
    GenericSummary,
    b2c,
    b2b,
    vpo,
  },
};



// WEBPACK FOOTER //
// ./src/pages/account/contract/migration-plan.js